// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import '@/plugins/flexible'
import '@/plugins/mobileSelect.min'
import api from '@/config/api'
import MintUI from 'mint-ui'
/* MintUI 样式 */
import 'mint-ui/lib/style.css'
/* 公共样式 */
import './assets/less/index.less'
/** 患者端公共样式 */
import './assets/less/jidayi.less'
// 挂载请求信息
import * as $http from './services'
// 添加手势触摸事件，使用方法如 v-touch:swipeleft
import VueTouch from './plugins/touchEvent'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

Vue.use(Viewer)
Viewer.setDefaults({
  navbar: false,
  toolbar: false,
  title: false
})

Vue.use(VueTouch)

Vue.prototype.$http = $http
// store注入全局
Vue.prototype.$store = store

// 去除警告
Vue.config.productionTip = false
Vue.use(MintUI)

// 路由守卫
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  let title = to.meta.title
  if (title !== undefined && title !== null) {
    document.title = to.meta.title || ''
  } else {
    document.title = '在线咨询'
  }

  if (to.name === 'userReg' || to.name === 'counselor' || to.name === 'hospitalList') {
    store.commit('setShowBall', false)
  } else {
    store.commit('setShowBall', true)
  }

  if (Vue.$messagebox) {
    Vue.$messagebox.close()
  }

  if (api.tokenCheck) {
    if (store.getters.token) {
      next()
    } else {
      // 如果在白名单中
      if (api.routerWhiteList.indexOf(to.name) >= 0) {
        next()
      } else {
        // next({
        //   name: 'login'
        // })
        window.location.href = api.timeoutUrl
      }
    }
  } else {
    next()
  }
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js